import React from 'react'

import Form from '../components/Form/Form'

import { formData, sendInfo } from '../data/cgtData'
import { formAnalysis } from '../helpers/analysis'
import Navbar from '../components/Navbar'

const Cgt = () => {
    return (
        <div>
            <Navbar />
            <Form formData={formData} sendInfo={sendInfo} analysis={formAnalysis} />
        </div>
    )
}

export default Cgt
